import { ACTIONS } from '../../constants';

/**
 * dispatch valid input action
 * @param {*} dispatch
 * @param {*} filter
 * @param {*} value
 */
export const validInput = (dispatch: Function, filter: string, value: any) =>
  dispatch({
    type: ACTIONS.VALID_INPUT,
    filter,
    value,
    error: null,
  });

/**
 * dispatch invalid input action
 * @param {*} dispatch
 * @param {*} filter
 * @param {*} value
 * @param {*} error
 */
export const invalidInput = (
  dispatch: Function,
  filter: string,
  value: any,
  error: any
) =>
  dispatch({
    type: ACTIONS.INVALID_INPUT,
    filter,
    value,
    error,
  });

/**
 * dispatch reset error to remove any order details api error messages
 * @param {*} dispatch
 * @param {*} filter
 */
export const resetError = (dispatch: Function, filter: string) =>
  dispatch({
    type: ACTIONS.RESET_ERROR,
    filter,
  });

/**
 * dispatch reset input to clear email/phone based on order type
 * @param {*} dispatch
 * @param {*} filter
 */
export const resetInput = (dispatch: Function, filter: string) =>
  dispatch({
    type: ACTIONS.RESET_INPUT,
    filter,
  });
